export const FIELD_NAMES = Object.freeze({
  CITY: 'city',
  COMPANY: 'company',
  COUNTRY_CODE: 'countryCode',
  EMAIL: 'email',
  LINE1: 'line1',
  LINE2: 'line2',
  LINE3: 'line3',
  NAME: 'name',
  PHONE: 'phone',
  POSTAL_CODE: 'postalCode',
  STATE: 'state',
  RESIDENTIAL_INDICATOR: 'residentialIndicator',
});
